if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.dataset.comingSoon !== 'true') {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.dataset.comingSoon === 'true') return;
        if (this.submitButtons.some((button) => button.getAttribute('aria-disabled') === 'true')) return;

        this.handleErrorMessage();

        this.setSubmitButtonsLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.setSubmitButtonsLoading(false);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButtons.forEach((button) => button.removeAttribute('aria-disabled'));
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      get submitButtons() {
        const inForm = [...this.form.querySelectorAll('[type="submit"]')];
        const external = this.form.id
          ? [...document.querySelectorAll(`button[form="${this.form.id}"][type="submit"]`)]
          : [];
        return [...inForm, ...external];
      }

      setSubmitButtonsLoading(isLoading) {
        this.submitButtons.forEach((button) => {
          const spinner = button.querySelector('.loading__spinner');

          if (isLoading) {
            button.setAttribute('aria-disabled', true);
            button.classList.add('loading');
            spinner?.classList.remove('hidden');
            return;
          }

          button.classList.remove('loading');
          spinner?.classList.add('hidden');
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.dataset.comingSoon === 'true') {
          const comingSoonLabel = window.variantStrings.comingSoon;
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButtonText.textContent = comingSoonLabel;
          this.syncExternalSubmitButtons(true, comingSoonLabel);
          return;
        }

        const addToCartLabel = this.dataset.addToCartLabel || window.variantStrings.addToCart;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = addToCartLabel;
        }

        this.syncExternalSubmitButtons(disable, text || addToCartLabel);
      }

      syncExternalSubmitButtons(disable, text) {
        if (!this.form.id) return;

        document.querySelectorAll(`button[form="${this.form.id}"][type="submit"]`).forEach((button) => {
          const buttonText = button.querySelector('span:not(.loading__spinner)');

          if (disable) {
            button.setAttribute('disabled', 'disabled');
            if (text && buttonText) buttonText.textContent = text;
          } else {
            button.removeAttribute('disabled');
            if (buttonText) buttonText.textContent = text;
          }
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
